import { ErrorMessage, Field, Formik } from "formik";
import React from "react";
import { Button, Col, Form, FormGroup, Row } from "reactstrap";
import * as Yup from "yup";

const CommentForm = () => {
  const initialValues = {
    name: "",
    email: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email format").required("Email is required"),
    message: Yup.string().required("Message is required").min(10),
  });

  const onSubmit = (values, { resetForm }) => {
    resetForm();
  };

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {(formik) => (
        <Form onSubmit={formik.handleSubmit} className='theme-form p-0 mt-3'>
          <FormGroup>
            <Row>
              <Col lg='6' md='12' className='md-fgrup-margin'>
                <Field type='text' name='name' className='form-control' placeholder='your name' />
                <ErrorMessage name='name' component='div' className='text-danger' />
              </Col>
              <Col lg='6' md='12'>
                <Field type='email' name='email' className='form-control' placeholder='email address' />
                <ErrorMessage name='email' component='div' className='text-danger' />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Field as='textarea' name='message' className='form-control' rows='4' placeholder='message' />
            <ErrorMessage name='message' component='div' className='text-danger' />
          </FormGroup>
          <div className='form-button'>
            <Button type='submit' className='btn btn-theme theme-color'>
              send
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CommentForm;
